import { useEnableSerialNumberTracking } from '../feature-flags/hooks/use-enable-serial-number-tracking';
import { useSerialNumberTrackingFeatureGate } from './use-serial-number-tracking-feature-gate';

export const useIsSerialNumberTrackingAvailable = () => {
  const isFlagEnabled = useEnableSerialNumberTracking();
  const { isFeatureEnabled: isPlanEnabled } = useSerialNumberTrackingFeatureGate();

  return {
    isAvailable: isFlagEnabled && isPlanEnabled,
    isFlagEnabled,
    isPlanGated: isFlagEnabled && !isPlanEnabled,
  };
};
